import React from "react";
import "./services.scss";
import SectionHeader from "../section_header/SectionHeader";
import ServiceBox from "../service_box/ServiceBox";
import planningImg from "../../assets/service/planning.webp";
import interiorImg from "../../assets/service/residential.webp";
import exteriorImg from "../../assets/service/exterior.webp";
import commercialImg from "../../assets/service/commercial.webp";
const Services = () => {
  const serviceData = [
    {
      serviceName: "Planning & Construction",
      img: planningImg,
      content: `We provide complete planning and construction services.`,
    },
    {
      serviceName: "Residential Interior Design",
      img: interiorImg,
      content: `We create functional, stylish residential interiors.`,
    },
    {
      serviceName: "Commercial Interior Design",
      img: commercialImg,
      content: `We design efficient, brand-focused commercial interiors.`,
    },
    {
      serviceName: "Exterior Elevation Design",
      img: exteriorImg,
      content: `We design modern, visually striking exterior elevations.`,
    },
  ];

  return (
    <div className="services_main">
      <div className="service_header">
        <SectionHeader name={"SERVICES"} />
      </div>
      <div className="service_container">
        <div className="service_boxes">
          {serviceData.map((item, index) => (
            <ServiceBox
              serviceName={item.serviceName}
              img={item.img}
              content={item.content}
              key={index}
              index={index}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
